// extracted by mini-css-extract-plugin
export default {"poItem":"PoItem_poItem__GMBpy"};